__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "call-center-portal";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.14.0", () => (Promise.all([__webpack_require__.e(655), __webpack_require__.e(710), __webpack_require__.e(158)]).then(() => (() => (__webpack_require__(4158))))));
			register("@emotion/styled", "11.14.0", () => (Promise.all([__webpack_require__.e(710), __webpack_require__.e(393), __webpack_require__.e(860)]).then(() => (() => (__webpack_require__(1479))))));
			register("@module-federation/utilities", "3.1.58", () => (__webpack_require__.e(636).then(() => (() => (__webpack_require__(6636))))));
			register("@reduxjs/toolkit", "2.8.2", () => (__webpack_require__.e(879).then(() => (() => (__webpack_require__(9879))))));
			register("axios", "1.9.0", () => (__webpack_require__.e(447).then(() => (() => (__webpack_require__(4447))))));
			register("dayjs", "1.11.19", () => (__webpack_require__.e(353).then(() => (() => (__webpack_require__(4353))))));
			register("formik", "2.4.6", () => (Promise.all([__webpack_require__.e(84), __webpack_require__.e(710)]).then(() => (() => (__webpack_require__(8084))))));
			register("js-cookie", "3.0.5", () => (__webpack_require__.e(987).then(() => (() => (__webpack_require__(8987))))));
			register("jwt-decode", "4.0.0", () => (__webpack_require__.e(537).then(() => (() => (__webpack_require__(5537))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(710)]).then(() => (() => (__webpack_require__(961))))));
			register("react-redux", "9.2.0", () => (Promise.all([__webpack_require__.e(468), __webpack_require__.e(710)]).then(() => (() => (__webpack_require__(1468))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(924), __webpack_require__.e(405), __webpack_require__.e(710)]).then(() => (() => (__webpack_require__(3924))))));
			register("react", "18.3.1", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(6540))))));
			register("validator", "13.15.20", () => (__webpack_require__.e(761).then(() => (() => (__webpack_require__(7761))))));
			register("yup", "1.6.1", () => (__webpack_require__.e(664).then(() => (() => (__webpack_require__(2664))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};